import * as React from 'react';
import { useBootstrapReady } from '@shared/lib/Bootstrap/useBootstrapReady';

import ExternalLocaleResources from '../../../ExternalLocaleResources/ExternalLocaleResources';

interface Props {
	children: React.ReactNode;
}

export const BootstrapGate: React.FC<Props> = ({ children }) => {
	const ready = useBootstrapReady();

	return (
		<>
			<ExternalLocaleResources />
			{ready && children}
		</>
	);
};
